export const APP_KPI_NAME = {
  PCS_TRANSACTION: "pcs_transaction", // = state-changing business actions DONE
  PCS_API_CALL: "pcs_api_call", // = all backend calls DONE
  PCS_INQUIRY: "pcs_inquiry", // = read-only user inquiries -> search/filter DONE
  PCS_LOGIN: "pcs_login", // = user login/logout DONE
  PCS_LOGIN_STAGE: "pcs_login_stage", // = diagnostic login stage timing
  PCS_INITIAL_SCREEN_LOAD: "pcs_initial_screen_load", // = first usable render DONE
  PCS_FIELD_NAVIGATION: "pcs_field_navigation", //
  PCS_SCREEN_NAVIGATION: "pcs_screen_navigation", // = screen-to-screen DONE
  PCS_REGULAR_REPORT_GENERATION: "pcs_regular_report_generation", // TBD
  PCS_MONTHLY_REPORT_GENERATION: "pcs_monthly_report_generation", // TBD
  PCS_AUTH_LOGIN_REDIRECT_STARTED: "auth_login_redirect_started", //DONE
  PCS_AUTH_SESSION_READY: "auth_session_ready", //DONE
  PCS_APP_ROUTE_CONTEXT: "app_route_context", //DONE
};
